
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as acresToSquareFeetw9QIts7WjqMeta } from "/home/runner/work/fields-calculators/fields-calculators/pages/converters/acresToSquareFeet.vue?macro=true";
import { default as celsiusToFahrenheit4pbSfFLZuoMeta } from "/home/runner/work/fields-calculators/fields-calculators/pages/converters/celsiusToFahrenheit.vue?macro=true";
import { default as cmToFeetwxSzsgYRqzMeta } from "/home/runner/work/fields-calculators/fields-calculators/pages/converters/cmToFeet.vue?macro=true";
import { default as cmToInchesmMaCel9O83Meta } from "/home/runner/work/fields-calculators/fields-calculators/pages/converters/cmToInches.vue?macro=true";
import { default as gramsToOuncesaS3yGk3xIkMeta } from "/home/runner/work/fields-calculators/fields-calculators/pages/converters/gramsToOunces.vue?macro=true";
import { default as hpToKwC7D8OvTqDnMeta } from "/home/runner/work/fields-calculators/fields-calculators/pages/converters/hpToKw.vue?macro=true";
import { default as inchesToFeetUyIuifz089Meta } from "/home/runner/work/fields-calculators/fields-calculators/pages/converters/inchesToFeet.vue?macro=true";
import { default as kgToLbs9RNgp5H6jnMeta } from "/home/runner/work/fields-calculators/fields-calculators/pages/converters/kgToLbs.vue?macro=true";
import { default as kmToMilesWA5MqEROsGMeta } from "/home/runner/work/fields-calculators/fields-calculators/pages/converters/kmToMiles.vue?macro=true";
import { default as litersToGallonsIcHW2jU2eSMeta } from "/home/runner/work/fields-calculators/fields-calculators/pages/converters/litersToGallons.vue?macro=true";
import { default as metersToFeetL7bti0ClCKMeta } from "/home/runner/work/fields-calculators/fields-calculators/pages/converters/metersToFeet.vue?macro=true";
import { default as metersToYards4VwxFI5YjTMeta } from "/home/runner/work/fields-calculators/fields-calculators/pages/converters/metersToYards.vue?macro=true";
import { default as mlToCupsEadp4AKd91Meta } from "/home/runner/work/fields-calculators/fields-calculators/pages/converters/mlToCups.vue?macro=true";
import { default as mmToInchesQvMgeaLU3uMeta } from "/home/runner/work/fields-calculators/fields-calculators/pages/converters/mmToInches.vue?macro=true";
import { default as mphToKphy8dGWrcbTkMeta } from "/home/runner/work/fields-calculators/fields-calculators/pages/converters/mphToKph.vue?macro=true";
import { default as poundsToOuncesjsc07zSa8zMeta } from "/home/runner/work/fields-calculators/fields-calculators/pages/converters/poundsToOunces.vue?macro=true";
import { default as radiansToDegreesvwLihr21IBMeta } from "/home/runner/work/fields-calculators/fields-calculators/pages/converters/radiansToDegrees.vue?macro=true";
import { default as indexeWs6p4RdqdMeta } from "/home/runner/work/fields-calculators/fields-calculators/pages/index.vue?macro=true";
export default [
  {
    name: "converters-acresToSquareFeet",
    path: "/converters/acresToSquareFeet",
    component: () => import("/home/runner/work/fields-calculators/fields-calculators/pages/converters/acresToSquareFeet.vue")
  },
  {
    name: "converters-celsiusToFahrenheit",
    path: "/converters/celsiusToFahrenheit",
    component: () => import("/home/runner/work/fields-calculators/fields-calculators/pages/converters/celsiusToFahrenheit.vue")
  },
  {
    name: "converters-cmToFeet",
    path: "/converters/cmToFeet",
    component: () => import("/home/runner/work/fields-calculators/fields-calculators/pages/converters/cmToFeet.vue")
  },
  {
    name: "converters-cmToInches",
    path: "/converters/cmToInches",
    component: () => import("/home/runner/work/fields-calculators/fields-calculators/pages/converters/cmToInches.vue")
  },
  {
    name: "converters-gramsToOunces",
    path: "/converters/gramsToOunces",
    component: () => import("/home/runner/work/fields-calculators/fields-calculators/pages/converters/gramsToOunces.vue")
  },
  {
    name: "converters-hpToKw",
    path: "/converters/hpToKw",
    component: () => import("/home/runner/work/fields-calculators/fields-calculators/pages/converters/hpToKw.vue")
  },
  {
    name: "converters-inchesToFeet",
    path: "/converters/inchesToFeet",
    component: () => import("/home/runner/work/fields-calculators/fields-calculators/pages/converters/inchesToFeet.vue")
  },
  {
    name: "converters-kgToLbs",
    path: "/converters/kgToLbs",
    component: () => import("/home/runner/work/fields-calculators/fields-calculators/pages/converters/kgToLbs.vue")
  },
  {
    name: "converters-kmToMiles",
    path: "/converters/kmToMiles",
    component: () => import("/home/runner/work/fields-calculators/fields-calculators/pages/converters/kmToMiles.vue")
  },
  {
    name: "converters-litersToGallons",
    path: "/converters/litersToGallons",
    component: () => import("/home/runner/work/fields-calculators/fields-calculators/pages/converters/litersToGallons.vue")
  },
  {
    name: "converters-metersToFeet",
    path: "/converters/metersToFeet",
    component: () => import("/home/runner/work/fields-calculators/fields-calculators/pages/converters/metersToFeet.vue")
  },
  {
    name: "converters-metersToYards",
    path: "/converters/metersToYards",
    component: () => import("/home/runner/work/fields-calculators/fields-calculators/pages/converters/metersToYards.vue")
  },
  {
    name: "converters-mlToCups",
    path: "/converters/mlToCups",
    component: () => import("/home/runner/work/fields-calculators/fields-calculators/pages/converters/mlToCups.vue")
  },
  {
    name: "converters-mmToInches",
    path: "/converters/mmToInches",
    component: () => import("/home/runner/work/fields-calculators/fields-calculators/pages/converters/mmToInches.vue")
  },
  {
    name: "converters-mphToKph",
    path: "/converters/mphToKph",
    component: () => import("/home/runner/work/fields-calculators/fields-calculators/pages/converters/mphToKph.vue")
  },
  {
    name: "converters-poundsToOunces",
    path: "/converters/poundsToOunces",
    component: () => import("/home/runner/work/fields-calculators/fields-calculators/pages/converters/poundsToOunces.vue")
  },
  {
    name: "converters-radiansToDegrees",
    path: "/converters/radiansToDegrees",
    component: () => import("/home/runner/work/fields-calculators/fields-calculators/pages/converters/radiansToDegrees.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/runner/work/fields-calculators/fields-calculators/pages/index.vue")
  }
]